import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
/**
 * Construye una instancia de i18next ya cableada con react-i18next y detección
 * de idioma (localStorage → navigator), persistiendo la elección.
 *
 * Cada app la llama una vez con sus catálogos y la pasa a `<I18nextProvider>`.
 * El tipado type-safe de las claves se logra augmentando `CustomTypeOptions`
 * en un `i18next.d.ts` de la app (no acá, que es agnóstico).
 *
 * @example
 * ```ts
 * import { createI18n } from 'i18n';
 * import { resources } from './resources';
 * export const i18n = createI18n({ resources, debug: import.meta.env.DEV });
 * ```
 */
export function createI18n(opts) {
    const instance = i18next.createInstance();
    // En SSR no hay localStorage ni navigator: el detector se omite y el idioma se fija con `lng`.
    const detect = opts.detectLanguage ?? true;
    if (detect)
        instance.use(LanguageDetector);
    void instance
        .use(initReactI18next)
        .init({
        resources: opts.resources,
        fallbackLng: opts.fallbackLng ?? 'es',
        supportedLngs: opts.supportedLngs ?? ['es', 'en'],
        defaultNS: opts.defaultNS ?? 'common',
        ns: opts.ns,
        debug: opts.debug ?? false,
        interpolation: { escapeValue: false },
        returnNull: false,
        ...(opts.lng ? { lng: opts.lng } : {}),
        ...(detect
            ? {
                detection: {
                    order: ['localStorage', 'navigator'],
                    lookupLocalStorage: opts.storageKey ?? 'i18nextLng',
                    caches: ['localStorage'],
                },
            }
            : {}),
    });
    return instance;
}
